import { createAsyncThunk } from '@reduxjs/toolkit'
import {
  calculateCriticalRiskRatioType,
  calculateShortTermCriticalRiskRatioType,
  calculateShortTermRiskRatioType,
  countRisksByCriticalityType,
  getSecurityControlsByPlanType,
  Plan,
} from '../../types/planTypes'
import {
  getAllPlans,
  addPlanApi,
  deletePlanApi,
  getPlanbyIdApi,
  updatePlanApi,
  getPlansByMissionIdApi,
  calculateCriticalRiskRatioApi,
  calculateShortTermCriticalRiskRatioApi,
  calculateShortTermRiskRatioApi,
  countRisksByCriticalityApi,
  getSecurityControlsByPlanApi,
} from '../../api/planApi'
import { handleError } from '../../utils/errorHandler'

export const getPlans = createAsyncThunk<
  {
    plans: Plan[]
    total: number
    totalPages: number
    status?: number
    erreur?: boolean
    message?: string
  },
  { search?: string; page?: number; pageSize?: number },
  { rejectValue: string }
>('plan/getAllPlans', async ({ search, page, pageSize }, thunkAPI) => {
  try {
    const response = await getAllPlans({ search, page, pageSize })
    return {
      plans: response.plans,
      total: response.total,
      totalPages: response.totalPages,
      status: response.status,
      message: response.message,
      erreur: response.erreur,
    }
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const deletePlan = createAsyncThunk<
  void,
  string,
  { rejectValue: string }
>('plan/deletePlan', async (PlanId, thunkAPI) => {
  try {
    await deletePlanApi(PlanId)
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const addPlan = createAsyncThunk<Plan, Plan, { rejectValue: string }>(
  'plan/addPlan',
  async (newPlan, thunkAPI) => {
    try {
      const response = await addPlanApi(newPlan)
      return response
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)
export const getPlanbyId = createAsyncThunk<
  Plan,
  string,
  { rejectValue: string }
>('plan/getPlanbyId', async (PlanId, thunkAPI) => {
  try {
    const response = await getPlanbyIdApi(PlanId)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const updatePlan = createAsyncThunk<
  Plan,
  { updatedPlan: Plan; _id: string },
  { rejectValue: string }
>('plan/updatePlan', async ({ updatedPlan, _id }, thunkAPI) => {
  try {
    const response = await updatePlanApi(updatedPlan, _id)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getPlansByMissionId = createAsyncThunk<
  { plans: Plan[]; total: number; totalPages: number },
  { page?: number; pageSize?: number; MissionId: string },
  { rejectValue: string }
>(
  'plan/getPlansByMissionId',
  async ({ page, pageSize, MissionId }, thunkAPI) => {
    try {
      const response = await getPlansByMissionIdApi(MissionId, page, pageSize)
      return {
        plans: response.plans,
        total: response.total,
        totalPages: response.totalPages,
      }
    } catch (error) {
      return thunkAPI.rejectWithValue(await handleError(error))
    }
  }
)

export const calculateCriticalRiskRatio = createAsyncThunk<
  calculateCriticalRiskRatioType,
  { idPlan: string },
  { rejectValue: string }
>('plan/calculateCriticalRiskRatio', async ({ idPlan }, thunkAPI) => {
  try {
    const response = await calculateCriticalRiskRatioApi(idPlan)
    console.log('hoooooooo', response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const calculateShortTermCriticalRiskRatio = createAsyncThunk<
  calculateShortTermCriticalRiskRatioType,
  { idPlan: string },
  { rejectValue: string }
>('plan/calculateShortTermRiskRatio', async ({ idPlan }, thunkAPI) => {
  try {
    const response = await calculateShortTermCriticalRiskRatioApi(idPlan)
    console.log('hoooooooo', response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const calculateShortTermRiskRatio = createAsyncThunk<
  calculateShortTermRiskRatioType,
  { idPlan: string },
  { rejectValue: string }
>('plan/calculateShortTermRiskRatio', async ({ idPlan }, thunkAPI) => {
  try {
    const response = await calculateShortTermRiskRatioApi(idPlan)
    console.log('hoooooooo', response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const countRisksByCriticality = createAsyncThunk<
  countRisksByCriticalityType,
  { idPlan: string },
  { rejectValue: string }
>('plan/countRisksByCriticality', async ({ idPlan }, thunkAPI) => {
  try {
    const response = await countRisksByCriticalityApi(idPlan)
    console.log(response)
    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})

export const getSecurityControlsByPlan = createAsyncThunk<
  getSecurityControlsByPlanType,
  { idPlan: string },
  { rejectValue: string }
>('plan/getSecurityControlsByPlan', async ({ idPlan }, thunkAPI) => {
  try {
    const response = await getSecurityControlsByPlanApi(idPlan)

    return response
  } catch (error) {
    return thunkAPI.rejectWithValue(await handleError(error))
  }
})
